import React from 'react';
import { useController, Control, ControllerProps } from 'react-hook-form';
import { Input as BaseInput } from 'components/ui';

interface FormInputProps {
  name: string;
  control: Control<any>;
  label?: string;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  type?: string;
  rules?: ControllerProps['rules'];
}

const FormInput: React.FC<FormInputProps> = ({
  name,
  control,
  label,
  placeholder,
  className,
  disabled = false,
  type = 'text',
  rules,
}) => {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
    rules,
  });

  return (
    <BaseInput
      {...field}
      type={type}
      label={label}
      placeholder={placeholder}
      error={error?.message}
      disabled={disabled}
      className={className}
    />
  );
};

export { FormInput };
